import { TrendingUp, TrendingDown } from "lucide-react"

/**
 * Carte KPI générique avec icône, valeur, et taux de croissance optionnel
 */
export default function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = "text-blue-600",
  iconBgColor = "bg-blue-100",
  growthRate,
  formatter = (v) => v,
  loading = false,
}) {
  const isPositiveGrowth = typeof growthRate === "number" && growthRate >= 0
  const hasGrowth = typeof growthRate === "number" && growthRate !== 0

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
      <div className="flex items-start justify-between mb-3">
        {Icon && (
          <div className={`p-3 ${iconBgColor} rounded-full`}>
            <Icon size={22} className={iconColor} />
          </div>
        )}
        {hasGrowth && (
          <div
            className={`flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full ${
              isPositiveGrowth
                ? "bg-green-50 text-green-700"
                : "bg-red-50 text-red-700"
            }`}
          >
            {isPositiveGrowth ? (
              <TrendingUp size={12} />
            ) : (
              <TrendingDown size={12} />
            )}
            {Math.abs(growthRate)}%
          </div>
        )}
      </div>
      <p className="text-gray-500 text-sm mb-1">{title}</p>
      <p className="text-2xl font-bold text-[#203a8a]">
        {loading ? "…" : formatter(value ?? 0)}
      </p>
      {subtitle && (
        <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
      )}
    </div>
  )
}
